export default {
  yellow: "#FEF3BD",
  purple: "#D4C4FB",
  blue: "#C4DEF6"
};
